import { clamp, hash01 } from "./chunk-0.jsx";
export function OledEye({
  kind,
  side,
  tilt = 0,
  blinkPulse,
  seedKey,
  boxW,
  boxH,
  gazeName
}) {
  const isLeft = side === 'left';
  const rot = (tilt || 0) * (isLeft ? -1 : 1);
  const seed = hash01(seedKey || `oled:${side}`);
  const blinkDurationS = 2.8 + seed * 2.0;
  const gazeDurationS = 3.6 + seed * 2.2;
  const blinkDuration = `${blinkDurationS.toFixed(2)}s`;
  const gazeDuration = `${gazeDurationS.toFixed(2)}s`;
  const blinkDelay = `${(-seed * blinkDurationS).toFixed(2)}s`;
  const gazeDelay = `${(-seed * gazeDurationS).toFixed(2)}s`;
  const wrapperStyle = {
    width: typeof boxW === 'number' ? `${Math.round(clamp(boxW, 0.12, 0.6) * 1000) / 10}%` : undefined,
    height: typeof boxH === 'number' ? `${Math.round(clamp(boxH, 0.2, 0.9) * 1000) / 10}%` : undefined
  };
  const gazeStyle = {
    animationName: gazeName || 'oledGaze',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
    animationDuration: gazeDuration,
    animationDelay: gazeDelay
  };
  if (kind === 'hearts') {
    return <div className="relative w-[28%] h-[58%] flex items-center justify-center" style={wrapperStyle}>
        <div className="w-full h-full flex items-center justify-center" style={gazeStyle}>
          <Heart className="w-[64%] h-[64%] text-white/95" />
        </div>
        <div className="absolute inset-0 bg-black origin-center pointer-events-none" style={{
        transform: 'scaleY(0)',
        animationName: 'oledBlink',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationDuration: blinkDuration,
        animationDelay: blinkDelay
      }} />
        <div className={`absolute inset-0 bg-black origin-center pointer-events-none transition-transform duration-150 ease-in-out ${blinkPulse ? 'scale-y-100' : 'scale-y-0'}`} />
      </div>;
  }
  if (kind === 'squares') {
    return <div className="relative w-[28%] h-[58%] flex items-center justify-center" style={wrapperStyle}>
        <div className="w-full h-full flex items-center justify-center" style={gazeStyle}>
          <div className="w-[52%] aspect-square rounded-[10%] bg-white/95" />
        </div>
        <div className="absolute inset-0 bg-black origin-center pointer-events-none" style={{
        transform: 'scaleY(0)',
        animationName: 'oledBlink',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationDuration: blinkDuration,
        animationDelay: blinkDelay
      }} />
        <div className={`absolute inset-0 bg-black origin-center pointer-events-none transition-transform duration-150 ease-in-out ${blinkPulse ? 'scale-y-100' : 'scale-y-0'}`} />
      </div>;
  }
  if (kind === 'round') {
    return <div className="relative w-[28%] h-[58%] flex items-center justify-center" style={wrapperStyle}>
        <div className="w-full h-full flex items-center justify-center" style={gazeStyle}>
          <div className="w-[58%] aspect-square rounded-full bg-white/95" />
        </div>
        <div className="absolute inset-0 bg-black origin-center pointer-events-none" style={{
        transform: 'scaleY(0)',
        animationName: 'oledBlink',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationDuration: blinkDuration,
        animationDelay: blinkDelay
      }} />
        <div className={`absolute inset-0 bg-black origin-center pointer-events-none transition-transform duration-150 ease-in-out ${blinkPulse ? 'scale-y-100' : 'scale-y-0'}`} />
      </div>;
  }
  if (kind === 'dashes') {
    return <div className="relative w-[28%] h-[58%] flex items-center justify-center" style={wrapperStyle}>
        <div className="w-full h-full flex items-center justify-center" style={gazeStyle}>
          <div className="w-[70%] h-[12%] rounded-full bg-white/90" />
        </div>
        <div className="absolute inset-0 bg-black origin-center pointer-events-none" style={{
        transform: 'scaleY(0)',
        animationName: 'oledBlink',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationDuration: blinkDuration,
        animationDelay: blinkDelay
      }} />
        <div className={`absolute inset-0 bg-black origin-center pointer-events-none transition-transform duration-150 ease-in-out ${blinkPulse ? 'scale-y-100' : 'scale-y-0'}`} />
      </div>;
  }
  if (kind === 'wink') {
    return <div className="relative w-[28%] h-[58%] flex items-center justify-center" style={wrapperStyle}>
        <div className="w-full h-full flex items-center justify-center" style={gazeStyle}>
          {isLeft ? <div className="w-[70%] h-[12%] rounded-full bg-white/90" /> : <div className="w-[56%] aspect-square rounded-full bg-white/95" />}
        </div>
        <div className="absolute inset-0 bg-black origin-center pointer-events-none" style={{
        transform: 'scaleY(0)',
        animationName: 'oledBlink',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationDuration: blinkDuration,
        animationDelay: blinkDelay
      }} />
        <div className={`absolute inset-0 bg-black origin-center pointer-events-none transition-transform duration-150 ease-in-out ${blinkPulse ? 'scale-y-100' : 'scale-y-0'}`} />
      </div>;
  }
  return <div className="relative w-[28%] h-[58%] flex items-center justify-center" style={wrapperStyle}>
      <div className="w-full h-full flex items-center justify-center" style={gazeStyle}>
        <div className="w-[72%] h-[44%] rounded-[18%] bg-white/95" style={{
        transform: `rotate(${rot}deg)`
      }} />
      </div>
      <div className="absolute inset-0 bg-black origin-center pointer-events-none" style={{
      transform: 'scaleY(0)',
      animationName: 'oledBlink',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',
      animationDuration: blinkDuration,
      animationDelay: blinkDelay
    }} />
      <div className={`absolute inset-0 bg-black origin-center pointer-events-none transition-transform duration-150 ease-in-out ${blinkPulse ? 'scale-y-100' : 'scale-y-0'}`} />
    </div>;
}
export function Heart({
  className = ''
}) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path fill="currentColor" d="M12 21s-7.2-4.6-9.6-8.6C.5 9.1 2.4 6 5.7 6c1.7 0 3.1.9 4 2.1.9-1.2 2.3-2.1 4-2.1 3.3 0 5.2 3.1 3.3 6.4C19.2 16.4 12 21 12 21z" />
    </svg>;
}
